import { z } from 'zod';

const createFromProductsBase = z
  .object({
    key: z
      .string()
      .min(3)
      .max(120)
      .regex(/^[A-Z0-9_:-]{3,120}$/, 'Use 3–120 uppercase letters, digits, _, :, or -'),
    name: z.string().trim().min(1).max(200),
    actionType: z.enum(['PERCENT_DISCOUNT', 'FLAT_DISCOUNT']),
    percent: z.string().optional().or(z.literal('')),
    flatRupees: z.string().optional().or(z.literal('')),
    startsAt: z.string().trim().min(1, 'Start date is required'),
    endsAt: z.string().trim().min(1, 'End date is required'),
  })
  .superRefine((val, ctx) => {
    if (val.actionType === 'PERCENT_DISCOUNT') {
      const n = Number(String(val.percent ?? '').replace(/,/g, ''));
      if (!Number.isFinite(n) || n <= 0 || n > 100) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['percent'],
          message: 'Enter a percent between 0.01 and 100',
        });
      }
    } else {
      const n = Number(String(val.flatRupees ?? '').replace(/,/g, ''));
      if (!Number.isFinite(n) || n <= 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['flatRupees'],
          message: 'Enter a flat amount greater than 0',
        });
      }
    }
    const start = val.startsAt.trim();
    const end = val.endsAt.trim();
    if (start && end && start > end) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['endsAt'],
        message: 'End must be on or after start',
      });
    }
  });

export const createOfferFromProductsSchema = createFromProductsBase;

export type CreateOfferFromProductsFormValues = z.input<typeof createOfferFromProductsSchema>;
